import { Rollemaster } from './../../../models/rollemaster';
import RequestService, { getQueryURL } from '../requestService';
import { client } from '../../client';
import { ImportsjekkResultat } from '../../../models/importsjekkResultat';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import { store } from '../../../app/store';
import { handleError } from '../../../features/layout/layoutSlice';

export default class RollemasterService extends RequestService<Rollemaster, 'rollemaster'> {
  xml_sjekk_import = async (fileContent: Blob, filNavn: string) => {
    try {
      const buffer = await fileContent.arrayBuffer();
      return await client.post<ImportsjekkResultat>(getQueryURL(`${this.serviceName}/xml-sjekk-import`, { filNavn }), buffer);
    } catch (err) {
      store.dispatch(handleError(err as Error));
    }
  };
  utførImportXML = async (fileContent: Blob, filNavn: string) => {
    try {
      const buffer = await fileContent.arrayBuffer();
      const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/xml-utfør-import`, { filNavn }), buffer);
      return { success: true, msg: res.message };
    } catch (err) {
      return { success: false, msg: (err as Error).message };
    }
  };
  importHoppOverEksisterendeFromXML = async (fileContent: Blob, filNavn: string) => {
    try {
      const buffer = await fileContent.arrayBuffer();
      const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/xml-import-hopp-over-eksisterende`, { filNavn }), buffer);
      return { success: true, msg: res.message };
    } catch (err) {
      return { success: false, msg: (err as Error).message };
    }
  };
  erstattImportFromXML = async (fileContent: Blob, filNavn: string) => {
    try {
      const buffer = await fileContent.arrayBuffer();
      const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/xml-erstatt-import`, { filNavn }), buffer);
      return { success: true, msg: res.message };
    } catch (err) {
      return { success: false, msg: (err as Error).message };
    }
  };
  eksportTilXml = async (id?: number) => await client.getFile(`${this.serviceName}/${id ? encodeURIComponent(id) + '/' : ''}xml-eksport`, 'GET');
  hentMaxRolleMasterId = async () => client.get<string>(`${this.serviceName}/HentMaxRolleMasterId`);
  hentRolleMaster = async (id?: number) =>
    client.get<Rollemaster>(`${this.serviceName}/${id}/HentRolleMaster`) as unknown as any as Rollemaster;

}
